import { styleCollections } from "@/mocks/gallery";

export default function Styles() {
  return (
    <section id="styles" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-xl">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">Art Styles</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">多元画风一站鉴赏</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              不同画风承载着不同的情绪与美学，点击任一风格即可进入对应的画廊图集，细品每一笔色彩。
            </p>
          </div>
          <a
            href="#gallery"
            className="inline-flex items-center whitespace-nowrap rounded-full border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition hover:border-primary-400 hover:text-primary-600 cursor-pointer"
          >
            查看全部画风
            <i className="ri-arrow-right-line ml-1.5"></i>
          </a>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {styleCollections.map((s, i) => (
            <a
              key={s.id}
              href="#gallery"
              className="group relative overflow-hidden rounded-xl bg-foreground-950"
            >
              <img
                src={s.image}
                alt={`${s.name}画风作品集`}
                className="h-56 w-full object-cover object-top opacity-80 transition duration-500 group-hover:scale-105 group-hover:opacity-60"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 flex items-end justify-between p-5">
                <div>
                  <span className="font-heading text-lg font-bold text-white">{s.name}</span>
                  <p className="mt-1 max-w-[200px] text-xs text-white/75">{s.desc}</p>
                </div>
                <span className="inline-flex items-center whitespace-nowrap rounded-full bg-accent-500 px-2.5 py-1 text-xs font-semibold text-foreground-950">
                  {s.count} 幅
                </span>
              </div>
              <div className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-white/15 text-white opacity-0 backdrop-blur transition group-hover:opacity-100">
                <i className="ri-arrow-right-up-line"></i>
              </div>
              <span className="absolute left-4 top-4 text-xs text-white/50">{String(i + 1).padStart(2, "0")}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}